export default "__VITE_ASSET__5d313f2b__"